// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2JwMt","signup":"Select_signup__3Juwl"};